import { Carousel } from 'bootstrap'

const carouselId = $('.carousel').attr('id')
const personaCarousel = document.getElementById(carouselId)

if (personaCarousel) {
	let carousel = new Carousel(personaCarousel, {
		interval: 5000,
		pause: 'hover'
	})

	personaCarousel.addEventListener('slid.bs.carousel', function(e) {
		var totalItems = $(this).find('.carousel-item').length
		var currentIndex = $(this).find('.active').index() + 1
		$('.counter').html('' + currentIndex + '/' + totalItems + '')
	})

	$('#'+carouselId+' > .indicator-content > .carousel-indicators span')
		.first()
		.addClass('active')

	carousel.pause()

	$(
		'#'+carouselId+' > .carousel-inner > .carousel-item > .content > .know-more'
	).on('click', function() {
		carousel.pause()
		$(this)
			.parents('.content')
			.siblings('.slider')
			.css('width', '100%')
		$(this)
			.parents('.content')
			.siblings('.slider')
			.css('visibility', 'visible')
	})

	$(
		'#'+carouselId+' > .carousel-inner > .carousel-item > .slider > div > div > .slider-close'
	).on('click', function() {
		carousel.cycle()
		$(this)
			.parents('.slider')
			.css('width', '0')
		$(this)
			.parents('.slider')
			.css('visibility', 'hidden')
	})
}

